module.exports = __webpack_public_path__ + "img/12.72da8c6f.jpg";